import React from 'react';
import { Box, Typography, Tooltip, useTheme } from '@mui/material';
import { InsertChartOutlined as ReportsIcon } from '@mui/icons-material';
import { SoftCard, SoftTitle } from './Soft';
import { tint } from './dashboardUtils';

const FILLS = ['lavender', 'sky', 'mint', 'peach', 'lemon', 'rose', 'slate'];

/** The reports as a grid of coloured icon tiles. Lives in the side rail. */
const ReportsPanel = ({ reports, onOpen }) => {
  const theme = useTheme();
  if (!reports?.length) return null;
  return (
    <SoftCard>
      <SoftTitle icon={ReportsIcon} fill="lavender" title="Reports" sub="Detailed tables you can filter and export" />
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 2.5 }}>
        {reports.map((r, i) => {
          const t = tint(theme, FILLS[i % FILLS.length]);
          return (
            <Tooltip key={r.key} title={r.description || ''} placement="top" enterDelay={500}>
              <Box
                role="button" tabIndex={0}
                onClick={() => onOpen(r.key)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpen(r.key); } }}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 2.5, px: 3, py: 2.5, borderRadius: 3, cursor: 'pointer', minWidth: 0,
                  bgcolor: t.bg, color: 'text.primary',
                  transition: 'transform 0.15s, box-shadow 0.15s',
                  '&:hover': { transform: 'translateY(-1px)', boxShadow: '0 8px 18px rgba(16,24,40,0.08)' },
                }}
              >
                <Box sx={{ width: 30, height: 30, borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : '#fff', color: t.ink, '& svg': { fontSize: '1rem' } }}>
                  {r.icon}
                </Box>
                <Typography noWrap sx={{ fontSize: '0.8125rem', fontWeight: 600 }}>{r.label}</Typography>
              </Box>
            </Tooltip>
          );
        })}
      </Box>
    </SoftCard>
  );
};

export default ReportsPanel;
